/* eslint-disable */
export default {
  forward: 'Weiterl.',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
